<template>
  <div>

    <v-container max-width="2100" style="background: white;">
      <v-card class="mx-auto my-5" max-width="2100">
        <v-system-bar class="py-5 px-3" color="#1973a5" style="color:#fff" dark> Cupos disponibles </v-system-bar>
      </v-card>
      <v-card class="mx-auto my-5 elevation-1" max-width="2100">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field max-width="200" class="mx-3" v-model="searchDistrito" label="Distrito"
              prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field max-width="200" class="mx-3" v-model="searchClinica" label="Clínica"
              prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mx-auto my-5" max-width="2100">
        <div style="max-height: 70vh;overflow-y: scroll;">
          <v-data-table :headers="headers" :items="filteredData" :single-expand="singleExpand" :expanded.sync="expanded"
            item-key="clinica" show-expand class="custom-table">
            <template v-slot:top>
            </template>
            <template v-slot:expanded-item="{ headers, item }">

              <td :colspan="headers.length">
                <v-data-table :headers="headersItems" :items="item.submenus">
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-3" @click="aceptarItem(item)">
                      mdi-eye-settings
                    </v-icon>
                  </template>
                </v-data-table>
              </td>
            </template>
          </v-data-table>
        </div>
        <v-btn color="blue darken-1" style="margin:1rem" text @click="close"> Cancelar </v-btn>
      </v-card>
    </v-container>
  </div>
</template>
<style>
.bg-primary-table {
  /* background: rgb(27 160 255 / 12%); */
  font-weight: 460;
}

tbody tr td {
  font-size: .7rem;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
  /* Cambia este color según tus preferencias */
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
  props: ["pacienteDataLista"],
  data() {
    return {
      headersItems: [
        { text: "Frecuencia", value: "frecuencia" },
        { text: "Turno", value: "turno" },
        { text: "Serología", value: "tipoPuesto" },
        { text: "Cupos Totales", value: "numero_totales", align: "center" },
        { text: "Cupos Ocupados", value: "numero_asignado", align: "center" },
        { text: "Cupos Disponibles", value: "numero_liberado", align: "center" },
        { text: "Acciones", value: "actions", align: "center" }
      ],
      expanded: [],
      singleExpand: false,
      valor1: 15,
      valor2: 10,
      ver: false,
      dataReporte: [],
      search: '',
      searchDistrito: '',
      searchClinica: '',
      sortBy: [{ key: 'cupos_disponible', order: 'asc' }],
      headers: [
        {
          text: "Clinica",
          align: "start",
          value: "clinica",
        },
        { text: "Distrito Clinica", value: "distrito" },
        { text: "Cupos Totales", value: "numero_totales_total", align: "center" },
        { text: "Cupos Ocupados", value: "numero_asignado_total", align: "center" },
        { text: "Cupos Disponibles", value: "numero_liberado_total", align: "center" },
      ]
    };
  },
  methods: {
    aceptarItem(item) {
      if (item.numero_liberado > 0) {
        this.$emit("itemArray", item);
      } else {
        Swal.fire({
          title: "Error!",
          text: "¡La opción seleccionada no tiene cupo disponible!",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
    close() {
      this.$emit("editClose");
    },
    dataInit() {
      const tipoPuesto = this.pacienteDataLista ? this.pacienteDataLista.serologia : null;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API + "/rep_cupos_agrupados/",
              {
                clinica_id: null, tipo_puesto: tipoPuesto
              },
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              this.dataReporte = res.data;
              const grupos = [];
              this.dataReporte.forEach((dato) => {
                const existente = grupos.find((grupo) => grupo.clinica === dato.clinica);
                if (existente) {
                  existente.numero_asignado_total += dato.numero_asignado;
                  existente.numero_liberado_total += dato.numero_liberado;
                  existente.numero_totales_total += dato.numero_totales;
                  // Agregar submenú
                  existente.submenus.push({
                    clinica: dato.clinica,
                    cas_id: dato.cas_id,
                    tipoPuesto: dato.tipoPuesto,
                    turno: dato.turno,
                    frecuencia: dato.frecuencia,
                    numero_asignado: dato.numero_asignado,
                    numero_liberado: dato.numero_liberado,
                    numero_totales: dato.numero_totales,
                  });
                } else {
                  grupos.push({
                    clinica: dato.clinica,
                    cas_id: dato.cas_id,
                    distrito: dato.distrito,
                    numero_asignado_total: dato.numero_asignado,
                    numero_liberado_total: dato.numero_liberado,
                    numero_totales_total: dato.numero_totales,
                    submenus: [
                      {
                        clinica: dato.clinica,
                        cas_id: dato.cas_id,
                        tipoPuesto: dato.tipoPuesto,
                        turno: dato.turno,
                        frecuencia: dato.frecuencia,
                        numero_asignado: dato.numero_asignado,
                        numero_liberado: dato.numero_liberado,
                        numero_totales: dato.numero_totales,
                      },
                    ],
                  });
                }
              });
              this.dataReporte = grupos;

              // Mostramos el resultado
              /* console.log("resultado de arreglo",grupos); */


            })
            .catch((res) => {
              console.log("Error:", res);

            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
  },
  mounted() {

  },
  computed: {
    filteredData() {
      if (!this.searchDistrito && !this.searchClinica) {
        return this.dataReporte;
      }

      let filtered = this.dataReporte;

      if (this.searchDistrito) {
        filtered = filtered.filter(item => item.distrito.toLowerCase().includes(this.searchDistrito.toLowerCase()));
      }

      if (this.searchClinica) {
        filtered = filtered.filter(item => item.clinica.toLowerCase().includes(this.searchClinica.toLowerCase()));
      }

      return filtered;
    },
    itemClass() {
      return (item) => {
        if (item.cupos_disponible === 0) {
          return ""; // Aplica la clase "bg-primary" para el color #007bff
        } else {
          return "bg-primary-table primary--text"; // No se aplica ninguna clase
        }
      };
    },
  },
  created() {
    console.log("Hola");
    this.dataInit();
  },
  components: {},
};
</script>